import { cx } from '@emotion/css';
import { Box } from '@mui/material';
import LinearLoadingIcon from '~/assets/icons/new/loading-02.svg?react';
import BubblesLoadingIcon from '~/assets/icons/new/loading-03.svg?react';

import { useStyles } from './Spinner.styles';

type Props = {
  show?: boolean;
  type?: 'linear' | 'bubbles';
  className?: string;
};

function Spinner({ show = false, type = 'linear', className }: Props) {
  const { classes } = useStyles();

  if (!show) {
    return null;
  }

  return (
    <Box
      data-testid="spinner"
      className={cx(classes['common--cmp--box-spinner'], className)}
    >
      {type === 'linear' ? <LinearLoadingIcon /> : <BubblesLoadingIcon />}
    </Box>
  );
}

export default Spinner;
